import React from "react";
import { IoLocationOutline } from "react-icons/io5";
import "../../Style/PropertyHeader/filterproparty.css";
import { useNavigate } from "react-router-dom";
import Loader from "../../Loader";
import { Helmet } from "react-helmet";
import { useParams } from "react-router-dom";

function Filterproparty({ propertyData, loding, error }) {
  const navigation = useNavigate();
  function rtrim(str, charToRemove = " ") {
    let regex = new RegExp(charToRemove + "+$", "g");
    return str.replace(regex, "");
  }
  const { propertytype } = useParams();
  const slug = propertytype?.split("_")[0];
  const metaData = {
    acquired: {
      title: "Premium Buyer and Seller Representation | Real Estate Agents",
      description:
        "Di Henneberry is your trusted Eastern Suburbs real estate agent. Premium buyer and seller representation across Bondi and Sydney's most prestigious suburbs.",
    },
    "for-sale": {
      title:
        "Sydney Property Sales Expert | Di Henneberry Luxury Property Sales",
      description:
        "Browse properties for sale with Di Henneberry, luxury property sales expert. Premium, personalized real estate guidance across the Sydney.",
    },
    sold: {
      title: "Di Henneberry | High-end Furnished Apartments in Sydney",
      description:
        "Explore Di Henneberry's sold property portfolio across Bondi and Sydney's Eastern Suburbs. Proof of high-end furnished apartments in Sydney.",
    },
    leased: {
      title: " Executive Leasing Sydney | Leased Properties | Di Henneberry",
      description:
        "Browse leased executive rentals across Bellevue Hill, Paddington & Woollahra. Di Henneberry specializes in high-end furnished apartments and corporate accommodation.",
    },
    "for-lease": {
      title:
        "Diamond Stays Furnished Rentals | Short-term Rental Manager Sydney ",
      description:
        "Browse Diamond Stays furnished rentals now. Sydney's finest short stays, corporate accommodation and executive leasing across the Eastern Suburbs.",
    },
    "executive-leasing": {
      title:
        "Executive Leasing Specialist Sydney | Diamond Stays | Di Henneberry",
      description:
        " Browse Diamond Stays executive rentals in Vaucluse, Bondi, Paddington & Coogee. Sydney's trusted executive leasing specialist for furnished rentals and premium short stays.",
    },
  };
  const data = metaData[slug] || {};

  return (
    <>
      <>
        <Helmet>
          <title>{data.title}</title>
          <meta name="description" content={data.description} />
        </Helmet>
      </>
      <div style={{ minHeight: !error ? "300px" : "" }} className="buyproperty">
        <div className="container-xxl p-0">
          <div className="row mt-0 gy-2">
            {loding ? (
              <Loader />
            ) : propertyData && propertyData.length > 0 ? (
              propertyData?.map((item, i) => {
                const {
                  id,
                  property_type,
                  price,
                  suburb,
                  new_or_established,
                  land_size,
                  land_size_unit,
                  number_of_bathrooms,
                  number_of_bedrooms,
                  outdoor_features,
                  property_images,
                  total_parkings,
                  price_in_text,
                } = item;
                return (
                  <div
                    className="col-lg-3 col-md-6 col-sm-6 col-12 mt-3"
                    key={i}
                    onClick={() => navigation(`/property-detail_${id}`)}
                  >
                    <div className="Buying_card" style={{ cursor: "pointer" }}>
                      <img src={property_images[0]} alt="img" />
                      <div className="card_content">
                        {property_type && (
                          <h5
                            className="m-0 text-capitalize"
                            style={{
                              whiteSpace: "noWrap",
                              overflow: "hidden",
                              textOverflow: "ellipsis",
                            }}
                          >
                            {property_type}{" "}
                          </h5>
                        )}
                        <span>
                          <IoLocationOutline />
                          {suburb}
                        </span>
                        {price ? (
                          <p className="m-0">${rtrim(price, ".0")}</p>
                        ) : price_in_text ? (
                          <p
                            className="m-0"
                            style={{
                              whiteSpace: "noWrap",
                              overflow: "hidden",
                              textOverflow: "ellipsis",
                            }}
                          >
                            {price_in_text}
                          </p>
                        ) : (
                          ""
                        )}
                      </div>
                    </div>
                  </div>
                );
              })
            ) : (
              <div className="d-flex align-items-center justify-content-center">
                {error}
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
}

export default Filterproparty;
